export const FILING_FEE = "Filing Fee";
export const ESTIMATED_TAX = "Estimated Tax*";
export const SALES_TAX = "Sales Tax*";

export const TIN_VERIFICATION_FEE ="TIN Verification"
export const USPS_MAILING_FEE ="USPS Mailing Fee"
export const E_DELIVERY_FEE ="eDelivery Fee"
export const STATE_FILING_FEE ="State Filing Fee"

export const FIELD_COUPON = "Coupon";

